/**
 * @fileoverview Section for Specify Listings Configuration page dedicated to matching selections
 *
 * @author Heesun Jun (hjun@yext.com)
 */
import yext from 'goog:yext';

import {AltBrandNamesConfig} from '/src/com/yext/listingslaunchstorm/js/enterprise/specifylistingconfiguration/data/altbrandnamesconfig';
import {MenuController} from '/ui/components/menu/menucontroller';
import {Table} from '/ui/components/table/table';
import {Tooltip} from '/ui/components/tooltip/tooltip';

/**
 * @param {{
 *  selectedAltNameId: string,
 *  setSelectedAltBrand: Function,
 *  altBrandNames: !Array<AltBrandNamesConfig>,
 * }} props
 * @return {React.ReactNode}
 */
export function MatchingSettings({
  selectedAltNameId,
  setSelectedAltBrand,
  altBrandNames,
}) {
  const getIdToNameMap = array => {
    const dictionary = Object.fromEntries(array.map(item => [item.id, item.name]));
    dictionary[''] = yext.msg('None (Default)');
    return dictionary;
  };

  const idToNameMap = getIdToNameMap(altBrandNames);

  const COLUMN_IDS = {
    MATCHING: 'matching',
    SELECT: 'select',
  };

  const matchingColumns = [
    {
      id: COLUMN_IDS.MATCHING,
      label: yext.msg('Matching'),
      width: '240px',
    },
    {
      id: COLUMN_IDS.SELECT,
      label: '',
    },
  ];

  const defaultAction = {
    name: yext.msg('None (Default)'),
    callback: () => setSelectedAltBrand(new AltBrandNamesConfig({
      id: '',
      name: yext.msg('None (Default)'),
      description: undefined,
    })),
  };

  const actions = altBrandNames.map(altBrandName => ({
    name: altBrandName.name,
    callback: () => setSelectedAltBrand(altBrandName),
    secondaryText: altBrandName.description,
  }));

  const matchingDataRows = [
    {
      id: 'alternative-names-selector',
      [COLUMN_IDS.MATCHING]: <Tooltip
        unclearText={yext.msg('Alternate Brand Name Fields')}
        tooltipText={yext.msg('If your business uses multiple brand names, specify a field in Content that contains alternate brand names to search for.')}
      />,
      [COLUMN_IDS.SELECT]: <MenuController
        actions={[defaultAction, ...actions]}
        label={idToNameMap[selectedAltNameId]}
        allowContainerOverflow
      />,
    },
  ];

  return (
    <div className="configuration-section">
      <Table
        label={yext.msg('Matching')}
        columns={matchingColumns}
        dataRows={matchingDataRows}
      />
    </div>
  );
}
